import { render, staticRenderFns } from "./OtherMenu.vue?vue&type=template&id=28bba528&"
import script from "./OtherMenu.vue?vue&type=script&lang=js&"
export * from "./OtherMenu.vue?vue&type=script&lang=js&"
import style0 from "./OtherMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OtherMenu.vue"
export default component.exports